module.exports = __webpack_public_path__ + "5328a9896c8f1aefe7cda7cc93871efc.png";